/* eslint-disable max-len */
module.exports = {
  // 零碎名词
  get_secret_key: 'Get SecretKey',
  history_session: 'History Session',
  remember_session: 'Remember Session',
  create_session: 'Create Session',
  edit_session: 'Edit Session',
  delete_session: 'Delete Session',
  user_type: 'User Type',
  authorized_user: 'Authorized user',
  root_account: 'Root account',
  sub_account: 'Sub-account',
  collaborator_id: 'collaborator',
  add_user: 'Add User',
  specified_domain: 'Specified Domain',
  MAZ_configuration: 'MAZ configuration',
  MAZ_state: {
    MAZ: 'Enabled',
    OAZ: 'Off',
    Off: 'Off',
    AccessDenied: 'Unknown (No access to HeadBucket)',
    Unknown: 'Unknown',
  },

  // 存储桶
  bucket: [
    'Buckets', // 0
    'Bucket: {bucket}', // 1
  ],
  add_bucket: 'Add Bucket',
  bucket_name: 'Bucket Name',
  bucket_detial: 'Bucket Info',
  switch_bucket: 'Switch Bucket',
  select_bucket: 'Select bucket',
  remote_folder: 'Bucket Path',
  create_bucket: ['Create bucket', 'Bucket created'],
  delete_bucket: ['Delete bucket', 'Bukcet deleted'],
  edit_bucket: 'Edit bucket',
  edit_bucket_acl: 'Edit bucket ACL',
  edit_bucket_version_control: 'Edit version control',

  // 标签
  tag: 'tag',
  bucket_tag: 'Bucket Tag',
  tag_management: 'Tag management',
  tag_key: 'Tab key',
  tag_value: 'Tab Value',
  add_tags: 'Add Tags',
  tag_help: 'Learn more',
  delete_tag: 'Delete Tag',
  set_tag: 'Set Tag',

  // 域名
  domain: 'Domain',
  domain_management: 'Domain Management',
  default_cdn_domain: 'Default CDN Acceleration Domain',
  current_status: 'Status',
  acceleration_domain: 'Acceleration Domain Name',
  acceleration_region: 'Acceleration Region',
  origin_server_type: 'Origin Server Type',
  origin_server_domain_name: 'Origin Server Domain Name',
  origin_pull_authentication: 'Origin-pull Authentication',
  CDN_authentication: 'CDN Authentication',
  default_cdn_domain_help: 'Default CDN Acceleration Domain Guides',
  custom_cdn_domain_help: 'Custom CDN Acceleration Domain Guides',
  custom_cdn_domain_help_comment: [
    'Note: Make sure that the added domain name has been filed and the corresponding CNAME has been set on the DNS provider website.',
    'For more information or help, please refer to',
  ],
  custom_domain_help: 'Custom Origin Domain Guides',
  custom_domain_help_comment: [
    'Note: This bucket provides service in Mainland China. Please make sure that your domain has been filed. Domain that is not filed cannot be bound to the bucket in Mainland China as a custom domain.',
    'Meanwhile, set corresponding CNAME records on DNS service provider website and route to COS.',
    'For more information or help, please refer to',
  ],
  custom_cdn_domain: 'Custom CDN Acceleration Domain',
  custom_domain: 'Custom Origin Server Domain',
  domain_type: 'Origin Server Type',
  cname: 'CNAME',
  statu: 'Statu',
  speed_area_map: {
    mainland: 'Acceleration in Mainland China',
    overseas: 'Acceleration outside Mainland China',
    global: 'Global Acceleration',
  },
  statu_map: {
    online: 'online',
    offline: 'offline',
    processing: 'deploying',
    rejected: 'Domain name verification failed, domain name filing expired/because of cancellation',
    ENABLED: 'online',
    DISABLED: 'offline',
  },
  origin_type_map: {
    REST: 'Default origin server',
    cos: 'Default origin server',
    web: 'Static website origin server',
    WEBSITE: 'Static website origin server',
    ACCELERATE: 'Global acceleration origin server',
    V4_REST: 'Default origin server(old)',
  },

  // 访问路径
  access_path: ['Access Path', 'Access Path: {path}'],
  access_path_simple: 'Path',
  add_access_path_simple: 'Add Path',
  add_access_path: ['Add access path', 'Add access path'],
  edit_access_path: 'Edit access path',
  delete_access_path: ['Delete access path', 'Delete access path'],

  show_in_local_folder: 'Show in Folder',
  show_in_remote_folder: 'Show in Bucket',
  prefix_matching: 'Prefix match',

  region_name: 'Region',
  endpoint: 'Endpoint',
  access_domain: 'Domain',
  bucket_domain: 'Bucket domain',
  domainTypeMap: {
    defaultCos: 'Default Origin Domain',
    defaultCdn: 'Default CDN Acceleration Domain',
    customCdn: 'Custom CDN Acceleration Domain',
    customCos: 'Custom Origin Server Domain',
  },

  ETag: 'ETag',
  headers: 'Headers',

  // 对象
  object_url: 'Object location',
  copy_link_with_expires: 'Copy link with expires',
  copy_link_without_sign: 'Copy object url without signature.',
  copy_link_with_sign: 'Copy url with signature, select expires time',
  current_file_acl: 'Current file acl',
  loading_file_acl: 'Loading object acl',
  copy_files: {
    msg: '{count} file / folder copyed successfully',
    success_without_sign: 'Object url copy success, Link without signature.',
    success_with_sign: 'Temporary object url copy success, Link effective for {duration} {unit}.',
    success: '{count} file / folder pasted successfully',
    fail: '{count} file / folder pasted failed',
  },
  object_count: 'Number of Objects',

  // 权限
  permission: 'Permissions',
  public_permission: 'Public Permissions',
  acl: 'ACL',
  acl_simple: 'ACL',
  public_pemission: 'Public Permissions',
  acl_map: {
    'public-read-write': 'Public (read-write)',
    'public-read': 'Public read & Private write',
    private: 'Private (read-write)',
    default: 'Inherit',
    'tce-default': 'Default',
    AccessDenied: 'Unknown (No access to GetObjectACL)',
    Unknown: 'Unknown',
    'unknown-with-timeout': 'Unable to get (please select link type yourself)',
  },
  user_acl: 'User ACL',
  set_user_acl: 'Set user acl',
  delete_user_acl: 'Delete user acl',
  user_acl_map: {
    FULL_CONTROL: 'Full control',
    READ: 'Reads',
    WRITE: 'Write',
    READ_ACP: 'Read ACL',
    WRITE_ACP: 'Write ACL',
  },
  edit_acl: 'Edit ACL',
  permission_management: 'Permission Management',
  quick_auth: 'Quick Authorization',

  // 存储类型
  storage_class: 'Storage Class',
  storage_class_map: {
    STANDARD: 'Standard Storage',
    STANDARD_IA: 'Standard_IA Storage',
    ARCHIVE: 'Archive Storage',
    MAZ_STANDARD: 'MAZ_STANDARD Storage',
    MAZ_STANDARD_IA: 'MAZ_STANDARD_IA Storage',
    NEARLINE: 'Nearline Storage',
  },
  storage_class_short_map: {
    STANDARD: 'Standard',
    STANDARD_IA: 'Standard_IA',
    ARCHIVE: 'Archive',
    MAZ_STANDARD: 'MAZ_STANDARD',
    MAZ_STANDARD_IA: 'MAZ_STANDARD_IA',
    NEARLINE: 'Nearline',
  },
  edit_storage_class: 'Edit StorageClass',

  // 版本控制
  version_control: 'Versioning',
  versions: 'Versions',
  version_id: 'VersionId',
  version_map: {
    disabled: 'Disabled',
    enabled: 'Enabled',
    suspended: 'Suspended',
    accessdenied: 'Access Denied',
    unknown: 'Unknown',
  },
  deleted_flag: 'Deleted',
  versioning_document: 'Versioning documents',
  open_versioning: 'Open',

  // 分块上传
  object_path: 'Object Path',
  initiator_ID: 'Upload Initiator ID',
  owner_ID: 'Owner ID',
  uploaded_size: 'Uploaded Size',
  uploaded_part_count: 'Uploaded part count',
  uploadId: 'Upload Task ID',
  incomplete_multipart_upload: 'Incomplete multipart Upload',
  clear_incomplete_uploads: 'Clear Incomplete Multipart Uploads',
  multipart_upload_name: 'Multipart Upload Name',
  multipart_upload_path: 'Path',
  loading_incomplete_upload_info: 'Loading...',

  // 格式校验
  validate: {
    invalid_input: 'Format error found. Please enter again',
    path_name_length: 'Access path cannot be longer than 255 characters.',
    folder_name_length: 'File folder name cannot be longer than 255 characters.',
    empty_folder_name: 'Folder name is not allowed empty.',
    empty_file_name: 'File name is not allowed empty.',
    invalid_char_in_folder_name: 'file folder name include invalid characters \\ / : * ? " < > |',
    bucket_name_format_simple: 'Only support lowercase letters, numbers and \'-\'. Up to 50 characters',
    bucket_name_length: 'It cannot be longer than 50 characters.',
    bucket_name_char: 'Only support lowercase letters, numbers and "-". Up to 50 characters',
    bucket_name_end_with: ['Bucket name cannot start with "-"', 'Bucket name cannot end with "-"'],
    bucket_name_format: 'Only support lowercase letters, numbers and "-". Up to 50 characters',
    secret_id_empty: 'SecretId empty',
    secret_key_empty: 'SecretKey empty',
    region_key_empty: 'Region empty',
    secret_key_must_start_with_AKID: 'SecretId must start with "AKID"',
    secret_id_format: 'The number of SecretId characters should be 36 characters.',
    secret_key_format: 'The number of SecretKey characters should be 32 characters.',
    access_path_format: 'The format is Bucket or Bucket/Object-prefix, such as a-1251902136.',
    need_positive_int: 'Complete positive integer',
    support_number_and_letters: 'Support number, letters.',
    support_char_most: 'Note: {num} characters at most.',
    empty_input_content: 'Input cannot be empty',
    service_domain_format: 'Invalid service domain format',
    bucket_domain_format: 'Invalid bucket domain format',
    enter_account_id: 'Enter account ID',
    invalid_account_id_format: 'Invalid account ID format',
    cannot_be_root_via_sub: 'Account ID cannot be root account when account type is sub-account',
    choose_at_least_one_permission: 'Please choose at least one permission',
    submit_new_user: 'Please submit the new user',
    enter_a_full_tag_key_and_tag_value: 'Enter a full tag key and tag value',
    tag_value_length_cannot_be_greater_than_255_characters: 'Tag value length cannot be greater than 255 characters',
    tag_key_length_cannot_be_greater_than_127_characters: 'Tag key length cannot be greater than 127 characters',
    tag_keys_cannot_begin_with: "Tag keys cannot begin with Regular expression, '项目', 'project', 'qcs:'",
    repetitive_tag_keys_are_not_allowed: 'Repetitive tag keys are not allowed',
    share_valid_time: 'The longest valid time is 2 hours',
    only_allow_integer: 'Please enter positive integer',
    enter_6_extract_code: 'Please enter the 6-digit extraction code',
    folder_name: [
      'Folder name is not allowed to be empty',
      'File folder name cannot be longer than 255 characters',
      'Folder name is cannot begin with "/"',
      'Folder name can not contain continuous "/"',
      'Folder name is not allowed to be "..".',
      'The total length of current path is up to limit of 850 bytes.',
    ],
  },

  // 占位符
  placeholder: {
    file_prefix: 'Prefix matching',
    secret_id: 'Please enter API SecretId',
    secret_key: 'Please enter API SecretKey',
    add_path: 'Not required, add access path',
    add_remark: 'Not required, Add remark',
    bucket: 'Format such as: test-1250000000',
    region: 'Format such as: ap-guangzhou',
    root_account_id: 'Enter root account ID',
    sub_account_id: 'Enter sub-account ID',
    collaborator_id: 'Enter collaborator-account ID',
    tag_key: 'Enter a tag key',
    tag_value: 'Enter a tag value',
  },

  // 提示
  tips: {
    whether_to_enter_access_path:
      'If the current account has permissions for all buckets, you do not need to enter the access path; if the current account only has permissions for a bucket or a directory under the bucket, you need to enter the access path in the format: Bucket or Bucket / Object-prefix, As test-1250000000',
    empty_bucket_list: 'The bucket list is empty.',
    create_bucket_in_console:
      'Please create Bucket in <a href="https://console.cloud.tencent.com" class="login-operate">Console</a>',
    empty_file: 'No files',
    history_session_empty: 'No history session',
    empty_history_file: 'No history files',
    empty_files_or_folders: 'please choose the file/folder',
    delete_replication:
      'Note: current bucket has replication rules, delete action will be synchronized to target bucket.',
    share_replication:
      'Note: current bucket has replication rules. Upload and delete operations via sharing link will be synchronized to the target bucket',
    same_name_file_exist: 'If the file of the same name already exists:',
    access_path_describe:
      'Access path can be a [Bucket] or a [Path under the bucket]. Please make sure the added path is authorized.',
    private: 'private (read-write): need to verify your identity before do some operations on object',
    'public-read': 'public read & private write: anonymous read and write with identification.',
    'public-read-write': 'Everyone can do some operations on object.',
    show_thumbnail_will_generate_CI_fee:
      'Displaying thumbnail is based on Cloud Infinite (CI) in this region and it may incur basic image processing fee after opening.',
    show_thumbnail_will_generate_download_traffic: 'Displaying thumbnail will download complete file in this region and it may generate download traffic after opening.',
    version_control_describe:
      'When versioning is enabled, the historical versions of objects will exist as separate objects. They will occupy storage space and incur storage capacity fees.',
    clear_history_version: [
      'Clear history version',
      'This operation will clear the historical version of all objects in the current directory, please exercise caution!',
    ],

    read_bucket_ACL_permissions: 'Read bucket ACL permissions',
    write_bucket_ACL_permissions: 'Write bucket ACL permissions',
    read_object_ACL_permissions: 'Read object ACL permissions',
    write_object_ACL_permissions: 'Write object ACL permissions',

    choose_public_acl:
      'Note: Public read ACL allows anonymous users to read data in your bucket. It is recommended to use private ACL to ensure your data security.',

    /**
     * empty file list different tips
     */
    // 1. 无存储桶权限
    no_access_to_bucket: 'You don\'t have bucket permission.',
    concat_root_to_auth: 'Please contact the root account to request permission',
    // 2. 搜索无结果
    no_result_found: 'No results found',
    try_diffrent_keyword: 'Please try different keywords',
    // 3. 文件夹为空
    empty_folder: 'This folder is empty',
    drag_here: 'Drag here to upload',

    // 清空存储桶提示
    clear_bucket: [
      'Clearing bucket will clear all objects in this bucket, including object history versions and multipart uploads. (',
      'The cleared data is unrecoverable',
      ') If you confirm you want to clear the bucket, click "OK".',
    ],
    object_count:
      'Number of Objects refers to the number of objects in a bucket. When versioning is enabled, the historical versions of objects will exist as separate objects and be counted toward the total quantity.',
    specified_domain: 'If you modify the configured or added domain name, the object address will change accordingly.',
    open_versions: ['If you don\'t want to overwrite, you can {open} versioning.', 'open'],
    MAZ_configuration: 'After you set MAZ configuration, your data will be stored in different available zone.',
    empty_history_session: 'No history session.',
    tag_keys: 'Tag keys are case sensitive and support Chinese, a-z, A-Z, 0-9, +, -, _, =, /, ., :, @ and other characters',
    tag_values: 'Tag values are case sensitive and support Chinese, a-z, A-Z, 0-9, +, -, _, =, /, ., :, @ and other characters',
    folder_name: [
      '1. Numbers, letters, Chinese characters, and visible characters are allowed',
      '2. Use "/" to split path, you can quickly create subdirectories',
      '3. Empty folder, continuous "/" or starting with a "/" are not allowed',
      '4. ".." is not allowed to be a folder name',
    ],
  },

  // 确认提示
  confirm: {
    authorized_actions: ['Confirm Authorized Actions', 'Are you sure you want to authorize this account ID {id}?'],
    delete_actions: [
      'Confirm Delete Actions',
      'Are you sure you want to delete the authorization for this account ID {id}?',
    ],
    exit: 'There are upload / download tasks in progress. Are you sure to stop and exit?',
    logout: 'There are unfinished upload / download tasks. Are you sure to clear and logout?',
    rename_cover: 'Same file name exist, Do you confirm to cover it?',
    paste_param_cover: 'This operation overrides the file of this same name.Do you confirm to {type} it？',
    paste_cover: 'Pasting overrides the file of the same name. Do you confirm to paste it?',
    delete_files_or_folders:
      'Are you sure to delete files/folders? Note: the data is unrecoverable and accessible after deletion.',
    delete_task: 'Are you sure to delete all tasks? Note: the data is unrecoverable and accessible after deletion.',
    delete_access_path: 'Are you sure to delete this access path: {path}?',
    delete_bucket:
      'Do you confirm to delete this bucket: {bucket}? Note: Make sure that all the objects under the bucket are deleted, the data is unrecoverable and accessible after deletion.',
    delete_a_version_object: 'Do you confirm to delete this object "{name}" ( Version date is {time} ) ？',
    delete_some_version_object: 'Do you confirm to delete this folder "{name}"? Clearing will clear all objects in this folder, including object history versions. Note:The deleted files cannot be recovered or accessed.',
    delete_history_version_object:
      'Do you confirm that you want to clear the historical version of all files in the current directory? Note:The deleted files cannot be recovered or accessed.',
    clear_bucket: [
      'Confirm to clear the selected bucket?',
      'Clearing a bucket will delete all objects and incomplete multipart uploads in this bucket. The deleted data is unrecoverable and inaccessible.',
      'Please enter bucket name',
      'to clear it',
    ],
    pause_versioning: [
      'Are you sure you want to pause versioning?',
      'This suspends the creation of object versions for all operations but preserves any existing object versions. If you have any replication rules, they will be suspended as well.',
      'Versioning documents',
    ],
    delete_incomplete_uploads: 'Are you sure you want to delete the incomplete multipart uploads with path "{path}"?',
    clear_incomplete_uploads: 'Are you sure you want to clear all the incomplete multipart uploads in this bucket?',
    delete_session: [
      'Are you sure you want to delete session {name} ?',
      'Are you sure you want to delete quick access path {path} ?',
    ],
    delete_not_exist_sub_account: 'Sub account {subUin} does not exist. If confirm, it would delete authorized record with sub-account not exist.',
    check_remember: 'Uncheck will delete this session of SecretId & SecretKey (includes access path)',
    delete_tag: 'Are you sure you want to delete the tag {tag}',
  },

  /**
   * 统计弹窗
   */
  statistics_alert: [
    'Data in this page is provided by Cloud Monitor and has a certain delay. It is only for your reference. For detailed billing data, view in',
    'Billing Center',
    '.',
  ],

  /**
   *
   * 设置页面
   *
   * */
  reset_default: 'Reset Default',

  // 账号配置
  account: 'Account',

  // 关于配置
  about: 'About',
  cosBrowser: 'COSBrowser - Tencent Cloud COS Client',
  version_update: 'Update',
  has_new_version: 'new',
  no_new_version: 'No Update',
  check_update: 'Check for latest version.',
  update_now: 'Update now',
  update_tip: [
    'Found new version, do you get the update immediately?',
    'New version has major changes, whether to get the update immediately?',
  ],
  get_update: 'Get update',
  updating: 'A new version is downloading...',
  update_downloaded: 'New version downloaded successfully.',
  update_restart_app: 'The Setting will take effect after restart app, Restart current software now?',
  feedback: 'Feedback',
  instructions: 'Instructions',
  update_log: 'Updated Logs',
  local_log: 'Local Logs',
  privacy_policy: 'Privacy Policy',
  copyright: `2017-${new Date().getFullYear()} Tencent. All Rights Reserved.`,

  // 通用配置
  general: 'General',
  language: 'Language',
  service_domain: 'EndPoint/Service Domain',
  service_domain_placeholder: 'Default empty',
  service_domain_tip: 'Use as GetService Domain\nExample: cos.ap-beijing.myqcloud.com\nDefault empty',
  bucket_domain_setting: 'Bucket Domain Template',
  bucket_domain_tip:
    'Use as Bucket Domain Template\nSupport template "{Bucket}" and "{Region}"\nExample: {Bucket}.cos.{Region}.myqcloud.com\nDefault empty',
  force_use_https: 'Use HTTPS',
  not_use_https: 'Not use HTTPS',
  strict_ssl: 'Verify HTTPS certificates',
  ignore_ssl_error: 'Ignore HTTPS SSL errors',
  auto_update: 'Auto Update',
  path_style: 'Use Path Style',
  path_style_tip:
    'If use path style, bucket name will put in request pathname instead of domain\nThe bucket name also participates in signature calculate. For example, upload files to test-1250000000：\nPUT https://cos.ap-beijing.myqcloud.com/test-1250000000/1.jpg\n/test-1250000000/1.jpg Participate in signature computation as pathname parameter of signature.',

  // 代理配置
  proxyType: 'Proxy Type',
  proxy: 'Proxy',
  no_proxy: 'No proxy, direct connect',
  system_proxy: 'Use system proxy',
  custom_proxy: 'Use proxy',

  // 上传配置
  file_parallel_limit: 'File Parallel Limit',
  chunk_parallel_limit: 'Chunk Parallel Limit',
  chunk_retry_times: 'Error Retry Times',
  chunk_retry_interval: 'Chunk Retry Interval',
  upload_double_check: 'Secondary verification after uploading',
  upload_double_check_tips: '(After uploading, get the object information and compare with the local file)',
  upload_add_meta_md5: 'Calculate and add x-cos-meta-md5 Header (Slower)',
  upload_add_meta_md5_tips: '(Used to verify completeness when downloading objects from other channels)',

  // 下载配置
  change_location_tip: 'Change Location',
  ask_before_download: 'Ask where to save before download',
  download_to_location: 'Download to specified location',

  // 【上传】对象标签
  object_tag: 'Obect Tags',
  // 头部导航
  transfer: 'Transfer',
  view_on_mobile_app: 'View in Mobile App',
  switch_to_english: 'Switch to English',
  switch_to_chinese: 'Switch to Chinese',
  open_in_cos_client: 'Open in COS Client',
  cos_client_not_detected: 'COS client not detected, will redirect to COSBrowser download page',

  // 分页组件
  selected_items: 'Selected',
  items: 'items',
  pulled_items: 'Pulled',
  rows_per_page: 'Rows per page',
  page: 'Page',
  page_number: '',
  previous_page: 'Previous',
  next_page: 'Next',

  // 文件表格
  size: 'Size',
  modify_time: 'Modified Time',
  operation: 'Operation',
  no_permission: 'No permission',
  link_expired: 'The current link has expired',
  no_results_found: 'No results found',
  try_different_keywords: 'Try different keywords',
  folder_is_empty: 'This folder is empty',

  // 高级上传
  upload_files: 'Upload Files',
  select_upload_object: 'Select Upload Object',
  set_object_properties: 'Set Object Properties',
  select_files: 'Select Files',
  select_folder: 'Select Folder',
  file_folder: 'File/Folder',
  delete: 'Delete',
  no_files_selected: 'No files/folders selected',
  drag_upload_tip: 'Chrome and Firefox support drag-and-drop to this area for upload, multiple files/folders supported<br>Each file must be smaller than 512GB',
  object_properties_tip: 'Object property settings will apply to all objects to be uploaded. You can also set them directly on the file list page after upload.',
  storage_type: 'Storage Class',
  standard_storage_maz: 'Standard Storage (Multi-AZ)',
  low_frequency_storage_maz: 'Infrequent Access Storage (Multi-AZ)',
  standard_storage: 'Standard Storage',
  low_frequency_storage: 'Infrequent Access Storage',
  archive_storage: 'Archive Storage',
  access_permission: 'Access Permission',
  inherit_permission: 'Inherit Permission',
  private_read_write: 'Private',
  public_read_private_write: 'Public Read, Private Write',
  storage_method: 'Storage Method',
  if_same_name_file_exists: 'If a file with the same name exists',
  overwrite: 'Overwrite',
  rename: 'Rename',
  skip: 'Skip',
  object_tags: 'Object Tags',
  metadata: 'Metadata',
  parameter: 'Parameter',
  value: 'Value',
  select_project: 'Select Project',
  add_parameter: 'Add Parameter',
  next_step: 'Next',
  previous_step: 'Previous',
  upload: 'Upload',

  // 速度测试
  upload_domain_config: 'Upload Domain Configuration',
  default_domain: 'Default Domain',
  global_acceleration_domain: 'Global Acceleration Domain',
  need_enable_global_acceleration: '(Enable bucket global acceleration)',
  enter_custom_domain: 'Enter custom domain, e.g., www.example.com',
  download_domain_config: 'Download Domain Configuration',
  speed_test_tip: 'Tips: A temporary file will be uploaded to the bucket during speed testing and automatically deleted after completion',
  start_speed_test: 'Start Speed Test',

  // 传输列表
  name: 'Name',
  status: 'Status',
  waiting_upload: 'Waiting for Upload',
  file_checking: 'File Checking',
  upload_success: 'Upload Successful',
  upload_failed: 'Upload Failed',
  upload_paused: 'Upload Paused',
  remaining: 'Remaining',
  pause: 'Pause',
  start: 'Start',
  retry: 'Retry',
  cancel: 'Cancel',
  clear_completed: 'Clear Completed',
  more: 'More',
  pause_all: 'Pause All',
  start_all: 'Start All',
  delete_all: 'Delete All',
  uploading: 'Uploading',
  upload_failed_text: 'Upload Failed',
  upload_success_text: 'Upload Successful',

  // 桌面组件
  extract: 'Extract',
  prefix_search: 'Prefix Search',

  // 标签工具
  enter_tag_key: 'Please enter tag key',
  enter_tag_value: 'Please enter tag value',
  tag_limit_10: 'Maximum 10 tags',

  // 面包屑导航
  all_files: 'All Files',
  // 下载提示
  open_in_safari_to_download: 'Please click the top-right corner and open in Safari to download',
  // 文件大小限制
  file_size_exceeds_limit: 'The file size exceeds the limit. Only files within {maxSize} are allowed.',
  // 错误消息
  current_share_link_does_not_exist: 'Share link does not exist',
  current_share_link_has_expired: 'Share link has expired',
  extract_code_error_please_re_enter: 'Extraction code error, please re-enter',
  decoding_failed_please_try_again: 'Decoding failed, please try again',
  please_enter_6_digit_extract_code: 'Please enter a 6-digit extraction code',
  network_busy_please_refresh_page: 'Network busy. Please refresh the page',
  // 文件检查
  checking_files: 'Checking files.',
  // 错误消息
  no_files_to_upload: 'No files to upload',
  root_directory_prefix_search_not_allowed: 'Prefix search is not allowed in the root directory',
  // 速度测试
  please_enter_speed_test_parameters: 'Input speed test parameters',
  speed_test_parameter_exception: 'Speed test parameter exception',
  speed_test_in_progress_please_wait: 'Speed test in progress, please wait',
  please_enter_custom_upload_domain: 'Please enter custom upload domain',
  please_enter_custom_download_domain: 'Please enter custom download domain',
  // 速度测试状态
  upload_speed_test_in_progress: 'Testing upload speed',
  upload_speed_test_in_progress_with_percent: 'Upload speed test in progress ({percent})',
  upload_speed_test_completed: 'Upload speed test completed',
  upload_speed_test_failed: 'Upload speed test failed',
  upload_speed_test_failed_link_expired_please_re_acquire: 'Upload speed test failed: test link expired, please reacquire',
  upload_speed_test_failed_prefix: 'Upload speed test failed: ',
  download_speed_test_in_progress: 'Download speed test in progress',
  download_speed_test_completed: 'Download speed test completed',
  download_speed_test_failed: 'Download speed test failed: ',
  download_speed_test_failed_prefix: 'Download speed test failed: ',
  upload_completed: 'Upload completed',
  download_completed: 'Download completed',

  // 速度测试指标
  slowest: 'Slowest',
  fastest: 'Fastest',
  average: 'Average',
};
